import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPreEmployeeApi } from "../../api/services";

interface utilizationTypes {
  preEmployLoading: boolean;
  preEmployeeData: PreEmployementTypes | null;
}

export const getPreEmployeeReducer = createAsyncThunk<
  utilizationTypes["preEmployeeData"],
  { companyId: number; search?: string; status?: string | number, from_date?: string, to_date?: string }
>("utilization/getPreEmployeeReducer", async (data, thunkAPI) => {
  try {
    const result = await getPreEmployeeApi(data);
    if (result?.success) {
      return result?.data as utilizationTypes["preEmployeeData"];
    } else {
      throw new Error("Failed to fetch data");
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
const initialState: utilizationTypes = {
  preEmployeeData: null,
  preEmployLoading: false,
};

const UtilizationSlice = createSlice({
  name: "utilization",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getPreEmployeeReducer.pending,
      (
        state,
        action: PayloadAction<utilizationTypes["preEmployeeData"] | undefined>
      ) => {
        state.preEmployeeData = null;
        state.preEmployLoading = true;
      }
    );
    builder.addCase(
      getPreEmployeeReducer.fulfilled,
      (
        state,
        action: PayloadAction<utilizationTypes["preEmployeeData"] | undefined>
      ) => {
        state.preEmployeeData = action.payload ? action.payload : null;
        state.preEmployLoading = false;
      }
    );
    builder.addCase(
      getPreEmployeeReducer.rejected,
      (
        state,
      ) => {
        state.preEmployeeData = null;
        state.preEmployLoading = false;
      }
    );
  },
});

export default UtilizationSlice;
